import { createTheme } from "@mui/material";
const theme = createTheme({
    palette: {      
      primary: {
        main: '#B0122A',
        text: "#1A1A1A",
        contrastText: "#FFFFFF"
      },
      secondary:{
        main:'#F5F2EE',
        backgroundColor: "#FFFFFF"
      },
      Card: {
        main: "#EFEAE4"
      },
      action:{
        main:'#E6E2DD'
      },
      text:{
        main:'#1A1A1A',
        
      },
      success:{
        main:'#008080'
      },
      warning:{
        main:'#C89B5A'
      },
      error:{
        main:"#C30000"
      },
      default:{
        main:"#fff"
      },
      hover: {
        main: "#8E0F22"
      },
      grey:{
        main:'#6F6F6F'
      }
      
    },
    components:{
      dashboard:{
        titleColor:'#7A165B',
        saleCircleIcon:'#6FD195',
        rentCircleIcon:"#FFAE4C",
        saleCarCircleIcon:"#FFAE4C",
        inquiryOtherCircleIcon:"#ea615e",
        welcomeTextColor:"#AC2582",
        inquiryTitleColor:'#001619B2'
      }
    },

    typography:{ 
      "h4":{        
        fontWeight:'bold'
      } ,  
      "h6":{
        fontWeight:'bold'
      },
    },
    Stepper:{
      border:{
        main: '#111111'
      }
    },
    homePage:{
      navbar:'#FFFFFF',
      backgroundColor:'#F7F5F2'
    },
    mobileDrawer: {
      backgroundColor: "#FCFCFC"
    },
    button: {
      backgroundColor: {
        main: "#B0122A"
      },
      textColor: {
        main: "#FFFFFF"
      }
    }
  });
  export default theme;